import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useEscapeKey } from '../hooks/useEscapeKey';
const POPOVER_GUTTER = 8;
function getPopoverStyle(anchorPoint, popover, side, align) {
    const alignedLeft = align === 'start'
        ? anchorPoint.x
        : align === 'end'
            ? anchorPoint.x - popover.width
            : anchorPoint.x - popover.width / 2;
    const preferredTop = side === 'top' ? anchorPoint.y - popover.height - POPOVER_GUTTER : anchorPoint.y + POPOVER_GUTTER;
    return {
        left: Math.max(POPOVER_GUTTER, Math.min(alignedLeft, window.innerWidth - popover.width - POPOVER_GUTTER)),
        top: Math.max(POPOVER_GUTTER, Math.min(preferredTop, window.innerHeight - popover.height - POPOVER_GUTTER)),
    };
}
export function Popover({ open, anchorPoint, children, onOpenChange, side = 'top', align = 'center', role = 'dialog', 'aria-label': ariaLabel, className = '', layerClassName = 'z-dropdown', }) {
    const popoverRef = useRef(null);
    const [style, setStyle] = useState({});
    useEscapeKey(() => onOpenChange?.(false), open);
    useLayoutEffect(() => {
        if (!open || !anchorPoint || !popoverRef.current)
            return;
        const updatePosition = () => {
            const rect = popoverRef.current?.getBoundingClientRect();
            if (!rect)
                return;
            setStyle(getPopoverStyle(anchorPoint, rect, side, align));
        };
        updatePosition();
        window.addEventListener('resize', updatePosition);
        window.addEventListener('scroll', updatePosition, true);
        return () => {
            window.removeEventListener('resize', updatePosition);
            window.removeEventListener('scroll', updatePosition, true);
        };
    }, [align, anchorPoint, open, side]);
    if (!open || !anchorPoint || typeof document === 'undefined')
        return null;
    return createPortal(_jsx("div", { ref: popoverRef, role: role, "aria-label": ariaLabel, className: `fixed ${layerClassName} rounded-md border border-border-default bg-surface text-fg-primary shadow-lg ${className}`, style: style, children: children }), document.body);
}
//# sourceMappingURL=Popover.js.map